import { BasicParallelEnumerable } from "../BasicParallelEnumerable.js";
export const groupJoinAsync = (outer, inner, outerKeySelector, innerKeySelector, resultSelector, comparer) => {
    const generator = comparer ?
        groupJoinWithComparer(outer, inner, outerKeySelector, innerKeySelector, resultSelector, comparer) :
        groupJoinSimple(outer, inner, outerKeySelector, innerKeySelector, resultSelector);
    return new BasicParallelEnumerable({
        generator,
        type: 0
    });
};
const groupJoinWithComparer = (outer, inner, outerKeySelector, innerKeySelector, resultSelector, comparer) => {
    return async () => {
        const innerKeyMap = [];
        for await (const innerValue of inner) {
            const key = await innerKeySelector(innerValue);
            const record = innerKeyMap.find(x => comparer(x.key, key));
            if (record) {
                record.values.push(innerValue);
            }
            else {
                innerKeyMap.push({ key, values: [innerValue] });
            }
        }
        const outerValues = await outer.toArray();
        const resultPromises = outerValues.map(async (outerValue) => {
            const key = await outerKeySelector(outerValue);
            const innerRecord = innerKeyMap.find(x => comparer(x.key, key)) ?? { key, values: [] };
            return resultSelector(outerValue, innerRecord.values);
        });
        return await Promise.all(resultPromises);
    };
};
const groupJoinSimple = (outer, inner, outerKeySelector, innerKeySelector, resultSelector) => {
    return async () => {
        const innerKeyMap = new Map();
        for await (const innerValue of inner) {
            const key = await innerKeySelector(innerValue);
            const values = innerKeyMap.get(key);
            if (values) {
                values.push(innerValue);
            }
            else {
                innerKeyMap.set(key, [innerValue]);
            }
        }
        const outerValues = await outer.toArray();
        const resultPromises = outerValues.map(async (outerValue) => {
            const key = await outerKeySelector(outerValue);
            const values = innerKeyMap.get(key) ?? [];
            return resultSelector(outerValue, values);
        });
        return await Promise.all(resultPromises);
    };
};
